var PALETTE_COLORS = [
    '#2682cd',
    '#3d9fa1',
    '#40a370',
    '#4856d6',
    '#4abd81',
    '#51d4d6',
    '#68a4d5',
    '#7852d2',
    '#935c09',
    '#a55dbd',
    '#c89229',
    '#d65ab0',
    '#ed6779',
    '#f29cc4',
    '#ff9854',
    '#ffb72b',
];
var stringToNumber = function (input) {
    var hash = 0;
    if (input.length === 0) {
        return hash;
    }
    for (var index = 0; index < input.length; index++) {
        var chr = input.charCodeAt(index);
        hash = (hash << 5) - hash + chr;
    }
    return Math.abs(hash);
};
var getPaletteColorById = function (id) {
    return PALETTE_COLORS[id % PALETTE_COLORS.length];
};
export var getPaletteColorByString = function (key) {
    return getPaletteColorById(stringToNumber(key));
};
//# sourceMappingURL=paletteColor.js.map